import Translatable from "@/components/translatable_text/Translatable";

function Solution() {
  return (
<section className="my-20">
  <div className="container">
    <div className="flex justify-center">
      <div className="w-full lg:w-11/12">
        <div className="cont pb-12 md:pt-16 border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
            <div className="md:col-span-3 mb-8 md:mb-0">
              <h6 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800">
                <Translatable>The Consultation Story</Translatable>
              </h6>
            </div>
            <div className="md:col-span-9">
              <div className="text">
                <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                  <Translatable>At GCAD, consultation is not a single advisory step — it is a
                  continuous partnership. We operate as an integrated technical
                  consultant, accompanying organizations from initial intake to
                  final delivery. Through the Technology Project Protocol
                  Management (TPPM), we supervise every implementation stage,
                  ensuring clarity in technical decisions, alignment in
                  execution, and confidence in delivery.</Translatable>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  );
}

export default Solution;
